import format from 'date-fns/format'
import React, { useContext, useEffect, useState } from 'react'

import { Button } from '../../../../components/common/Button'
import { Select } from '../../../../components/common/Select'
import { ContextLatestRequests } from '../../../../context/context_latestRequests'
import {
  Container,
  SelectContainer,
  StatusBox,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
} from './styles'

import { Eye } from '@phosphor-icons/react'
import { Title } from '../../styles'
import api from '../../../../services/api'

export const TableRequests = ({ data, getOccurrence, openDetails }) => {
  const context = useContext(ContextLatestRequests)
  
  if (!context) {
    return <div>Loading...</div>;
  }
  
  const { handleFilters, filter, setOccurrencesList } = context

  return (
    <Container>
      <Table>
        <thead>
          <tr>
            <TableHeader>Nome</TableHeader>
            <TableHeader>ID ocorrência</TableHeader>
            <TableHeader>Posto</TableHeader>
            <TableHeader>Modalidade</TableHeader>
            <TableHeader>Horário de envio</TableHeader>
            <TableHeader>Status atual</TableHeader>
            <TableHeader>Segurança responsável</TableHeader>
            <TableHeader>Ver detalhes</TableHeader>
          </tr>
        </thead>
        <tbody>
          {data === undefined || data === null || data.length === 0 ? (
            <tr>
              <TableCellEmpty colSpan={8}>
                Nenhum dado encontrado
              </TableCellEmpty>
            </tr>
          ) : (
            data.map((val) => {
              return (
                <tr key={val.Occurrence.id}>
                  <TableCell>{val.Resident.name}</TableCell>
                  <TableCell>{val.Occurrence.code}</TableCell>
                  <TableCell>
                    {val.Occurrence.Base ? val.Occurrence.Base.outpost : ''}
                  </TableCell>
                  <TableCell>{val.Occurrence.type}</TableCell>
                  <TableCell>
                    {format(
                      new Date(val.Occurrence.created_at),
                      'dd/MM/yyyy HH:mm:ss',
                    )}
                  </TableCell>
                  <TableCell>
                    {<StatusBox status={val.Occurrence.status}>
                      {val.Occurrence.status === 'Fechado' ? 'Encerrado' : val.Occurrence.status} - #{val.Occurrence.code}
                    </StatusBox>}
                  </TableCell>
                  <TableCell>
                    {!val.Employee || val.Employee.length === 0 ? '-' : val.Employee.name}
                  </TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => {
                        getOccurrence(val)
                        openDetails()
                      }}
                      backgroundColor="#00517D"
                      type="button"
                      padding="0 0 0 0.2rem"
                    >
                      <Button.Content title="Ver detalhe" color="#fff" />
                      <Button.Icon>
                        <Eye size={24} color="#fff" />
                      </Button.Icon>
                    </Button.Root>
                  </TableCell>
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    </Container>
  )
}
